import CitySalaryPageTemplate from "@/components/CitySalaryPageTemplate";
import { CITY_SALARY_DATA } from "@/data/citySalaryData";

export default function SoftwareEngineerHyderabad() {
  return <CitySalaryPageTemplate data={CITY_SALARY_DATA["software-engineer-hyderabad"]} />;
}
